export const EventCreatePlaceholders = {
    "{EventName}": "Event name",
    "{EventType}": "Event type",
    "{PersonnelList}": "Personnel list",
    "{StartTime}": "Start time",
    "{EndTime}": "End time",
    "{Actioner}": "Actioner",
    "{CreationDate}": "Creation date",
    "{Location}": "Location",
    "{RecursiveInfoIfRecursive}": "Recursive info (if recursive)",
    "{TaskNameIfRelated}": "Task name (if related)",
    "{TaskURLIfRelated}": "Task URL (if related)",
};

export const EventReSchedulePlaceholders = {
    "{EventName}": "Event name",
    "{EventType}": "Event type",
    "{PersonnelList}": "Personnel list",
    "{OldStartTime}": "Old Start time",
    "{OldEndTime}": "Old End time",
    "{NewStartTime}": "New Start time",
    "{NewEndTime}": "New End time",
    "{Actioner}": "Actioner",
    "{CreationDate}": "Creation date",
    "{ReScheduleDate}": "Reschedule date",
    "{Location}": "Location",
    "{SingleEventOrSeriesIfRecursive}": "Single event or series(if recursive)",
    "{OldRecursiveInfoIfRecursive}": "Old Recursive info (if recursive)",
    "{NewRecursiveInfoIfRecursive}": "New Recursive info (if recursive)",
    "{TaskNameIfRelated}": "Task name (if related)",
    "{TaskURLIfRelated}": "Task URL (if related)",
};

export const EventDeletePlaceholders = {
    "{EventName}": "Event name",
    "{EventType}": "Event type",
    "{PersonnelList}": "Personnel list",
    "{StartTime}": "Start time",
    "{EndTime}": "End time",
    "{Actioner}": "Actioner",
    "{CreationDate}": "Creation date",
    "{CancellationDate}": "Cancellation date",
    "{Location}": "Location",
    "{SingleEventOrSeriesIfRecursive}": "Single event or series(if recursive)",
    "{RecursiveInfoIfRecursive}": "Recursive info (if recursive)",
    "{TaskNameIfRelated}": "Task name (if related)",
    "{TaskURLIfRelated}": "Task URL (if related)",
};
